import { Person } from '~/types'
import { PublishDate } from './publish-date'
import { personPhotoSrc } from '../human'

export const Byline = ({
  authors,
  date,
}: {
  authors: Person[]
  date: Date | null
}) => {
  const [primaryAuthor] = authors

  return (
    <div className="byline">
      {primaryAuthor?.photo && (
        <img
          alt=""
          className="byline-photo"
          src={personPhotoSrc(primaryAuthor.photo, 160)}
        />
      )}
      <div className="byline-meta">
        {authors.length > 0 && (
          <div className="byline-authors body-m text-brand-dark">
            {authors.map((author, index) => (
              <span className="byline-author" key={author.slug}>
                {author.email ? (
                  <a href={`mailto:${author.email}`}>{author.name}</a>
                ) : (
                  author.name
                )}
                {index < authors.length - 1 && ', '}
              </span>
            ))}
          </div>
        )}
        {date && (
          <div className="byline-date body-s text-brand-dark">
            <PublishDate date={date} />
          </div>
        )}
      </div>
    </div>
  )
}
